import { Field } from './basic_fields.js';
import { getDate, DateSpan, DatePoint, holidayChecker } from '../js/datelib.js';

if ([].find === undefined) {
    Array.prototype.find = function (callback) {
        let result = undefined;
        this.some(function (v, index) {
            if (callback(v)) {
                result = v;
                return true;
            }
        });
        return result;
    };
}

class DateField extends Field {
    constructor(selectorOrElem, options) {
        super(selectorOrElem, options);

        if (this.elem[0].tagName === 'DATE-PICKER')
            this.elem[0].holidayChecker = holidayChecker;
    }
    static keyName() { return 'date'; }
    getValue(silent) {return new DatePoint(this.elem[0].value, true)  }
    getClearValue() { return this.elem.val(); }
    getExportValue() { return this.elem.val(); }
    setValue(v) { this.elem.val(v); }
    onChange(f) {
        let self = this;
        this.elem.change(e => f(self.elem[0]));
    }

    static detect(elem) {
        return elem[0].tagName === 'DATE-PICKER';
    }

    reset(params) {
        params = params || {};
        if (!params.keepValue) {
            this.elem[0].reset(this.defaultValue);
        }
        if (!params.keepErrors) {
            this.clearErrors();
        }
    }

    isFilled(){
        return this.getClearValue() !== this.defaultValue; 
    }
}


class DateIntervalField extends DateField {
    /**
     *  @param {any} options :
     *      limitMax (boolean) - invalidates dateFields according to max-year attribute
     */
    constructor(selectorOrElem, options) {
        super(selectorOrElem, options);

        if (this.elemFrom[0].tagName === 'DATE-PICKER')
            this.elemFrom[0].holidayChecker = holidayChecker;
        if (this.elemTo[0].tagName === 'DATE-PICKER')
            this.elemTo[0].holidayChecker = holidayChecker;
    }
    static keyName() { return 'date-interval'; }
    getValue(silent) {
        let nameVal = (this.nameElem.length > 0 ? tools.removeExtraSpace(this.nameElem.val()) : undefined);
        if (nameVal !== undefined && (!this.options || !this.options.raw)) {
            nameVal = tools.escapeTags(nameVal);
        }
        return {
            dateFrom: this._getDateFrom(silent),
            dateTo: this._getDateTo(silent),
            name: nameVal,
            includeEnd: this.includeEnd
        };
    }
    getClearValue() {
        return this.elemFrom.val() + '+' + this.elemTo.val();
    }
    getExportValue() {
        return { dateFrom: this.elemFrom.val(), dateTo: this.elemTo.val() };
    }
    setValue(v) {
        let pair = v.split('+');
        this.elemFrom.val(pair[0]);
        this.elemTo.val(pair[1]);
    }
    init() {
        this.elemFrom = this.elem.find('#dateFrom, date-picker.input-from');
        this.elemTo = this.elem.find('#dateTo, date-picker.input-to');
        this.nameElem = this.elem.find('.dynamic-list-comment input');

        this.errorPeriodElem = this.elem.find("#datePeriodErr, .period-error");
        this.errorFromElem = this.elem.find("#dateFromErr, .from-error");
        this.errorToElem = this.elem.find("#dateToErr, .to-error");
        this.errorFromBound= this.elem.find("#dateFromBoundErr, .from-bound-err");
        this.errorToBound = this.elem.find("#dateToBoundErr, .to-bound-err");
        this.errorFromBoundMax= this.elem.find("#dateFromBoundErrMax, .from-bound-err-max");
        this.errorToBoundMax = this.elem.find("#dateToBoundErrMax, .to-bound-err-max");
        
        this.includeEnd = {};
    }

    _getDateFix(name) {
        let includeEndDate = true;
        this.options = this.options || [];
        if (this.options.include && this.options.include[name] !== undefined) {
            let includeEnd = this.options.include[name];
            if (typeof (includeEnd) === "function")
                includeEndDate = includeEnd(this);
            else
                includeEndDate = includeEnd;
        }
        this.includeEnd[name] = includeEndDate;
        return includeEndDate ? 0 : (name === 'to' ? -1 : 1);
    }

    _getDateFrom(silent) {
        let res = new DatePoint(this.elemFrom[0].value, true);
        return res.valid ? res.inc(silent ? 0 : this._getDateFix('from')) : res;
    }

    _getDateTo(silent) {
        let res = new DatePoint(this.elemTo[0].value, true);
        return res.valid ? res.inc(silent ? 0 : this._getDateFix('to')) : res;
    }

    resetErrors(binaryMap) {
        if (binaryMap === undefined) {
            binaryMap = 3;
            this.elem.find('.period-outside-error').hide();
            this.elem.find('.period-intersection-error').hide();
        }

        if (this.errorPeriodElem.is(":visible")) {
            this.errorPeriodElem.hide();
            this.elemFrom.removeClass('err');
            this.elemTo.removeClass('err');
        }

        if (binaryMap & 1) {
            this.errorFromElem.hide();
            this.errorFromBound.hide();
            this.errorFromBoundMax.hide();
            this.elemFrom.removeClass('err');
        }
        if (binaryMap & 2) {
            this.errorToElem.hide();
            this.errorToBound.hide();
            this.errorToBoundMax.hide();
            this.elemTo.removeClass('err');
        }
    }

    reset(params) {
        params = params || {};
        if (!params.keepValue) {
            this.elemFrom[0].reset()
            this.elemTo[0].reset();
        }
        if (!params.keepErrors) {
            this.resetErrors();
        }
    }

    check(autoValidation, sender, phase) {
        if (phase > 1)
            return true;

        var self = this;
        this.dateFrom = this._getDateFrom();
        this.dateTo = this._getDateTo();
       
        function setPeriodError() {
            self.errorPeriodElem.show();
            self.elemFrom[0].classList.add('err');
            self.elemTo[0].classList.add('err');
        }


        function processBoundElem(elem, errorElem, hadError = false) {
            if (!autoValidation || hadError/* || sender === dateElem*/) {
                elem.classList.add('err');
                errorElem.show();
            } else if (sender === elem && elem.classList.contains('err')) { // Redo: unreacheable condition because of this.resetErrors(1) and (2) inside "check"
                errorElem.show();
            }
        }

        var render = true,
            result = true;
        this.filled = this.dateFrom.valid || this.dateTo.valid;
        var valid = {
            from: this.dateFrom.valid,
            to: this.dateTo.valid
        };
        this.span = undefined;

        if (render) {
            const hadFromError = this.elemFrom[0].classList.contains('err');
            const hadToError = this.elemTo[0].classList.contains('err');
            this.resetErrors(1);
            this.resetErrors(2);

            let maxYearFrom = this.options?.limitMax && this.elemFrom.attr("max-year") ? this.elemFrom.attr("max-year").length == 4 ? this.elemFrom.attr("max-year") : new Date().getFullYear() + +this.elemFrom.attr("max-year") : null;
            let maxYearTo = this.options?.limitMax && this.elemTo.attr("max-year") ? this.elemTo.attr("max-year").length == 4 ? this.elemTo.attr("max-year") : new Date().getFullYear() + +this.elemTo.attr("max-year") : null;
        
            if (!valid.from) processBoundElem(this.elemFrom[0], this.errorFromElem, hadFromError);
            else if(this._getDateFrom().goesBefore(new DatePoint("01.01."+this.elemFrom.attr("min-year")))){
                valid.from = false;
                this.elemFrom[0].classList.add('err'); 
                processBoundElem(this.elemFrom[0], this.errorFromBound);
            } else if(maxYearFrom && (new DatePoint("31.12."+maxYearFrom)).goesBefore(this._getDateFrom())){
                valid.from = false;
                this.elemFrom[0].classList.add('err'); 
                processBoundElem(this.elemFrom[0], this.errorFromBoundMax);
            }

            if (!valid.to) processBoundElem(this.elemTo[0], this.errorToElem, hadToError);
            else if(this._getDateTo().goesBefore(new DatePoint("01.01."+this.elemTo.attr("min-year")))){
                valid.to = false
                this.elemTo[0].classList.add('err');
                processBoundElem(this.elemTo[0], this.errorToBound);
            } else if(maxYearTo && (new DatePoint("31.12."+maxYearTo)).goesBefore(this._getDateTo())){
                valid.to = false
                this.elemTo[0].classList.add('err');
                processBoundElem(this.elemTo[0], this.errorToBoundMax);
            }

            if(!valid.from || !valid.to){
                result = false;
            }
        }
        
        if(valid.from && valid.to) {
            this.resetErrors(3);

            if (this.dateTo.goesBefore(this.dateFrom)) {
                result = false;
                if (render) setPeriodError();
            }else{
                this.span = new DateSpan(this.dateFrom, this.dateTo);
            }
        }
        return result;
    }

    onChange(f) {
        let self = this;
        this.elemFrom.change(e => f(self.elemFrom[0]));
        this.elemTo.change(e => f(self.elemTo[0]));
    }

    static detect(elem) {
        return elem.find('date-picker').length == 2;
    }
}

class DateIntervalIgnoreEmptyField extends DateIntervalField{
    static keyName() { return 'date-interval-ignore'; }
    get ignore() { return !this.isFilled(); }
}


/**
 * Performs base date interval checks like intersections and out of the bounds.
 * How it works:
 *     1. If period is outside main period bounds, error will be shown
 *     2. If somewhere in period value was changed and it intersects with other period, error will be shown
 *     3. If intersection was found but reason is not editing some of periods, error will be shown in last period which intersects something.
 *     4. If no `outside` and `intersection` problems but all subtracting periods covers parent fully, `outside` error will be shown on active or last.
 * @param {any} fields list of fields
 * @param {any} options {parent: (field, optional)}
 */
function baseDateIntervalCheck(fields, options) {
    let result = {
        valid: true
    }
    let parent = options !== undefined ? options.parent : undefined;

    if (fields.length > 0) {
        fields.sort(function (a, b) {
            return (a.dateFrom.goesBefore(b.dateFrom) ? -1 : 1);
        });

        function toggleErrorHighlight(period, show) {
            if (show) {
                period.elemFrom.addClass('err');
                period.elemTo.addClass('err');
            } else {
                period.elemFrom.removeClass('err');
                period.elemTo.removeClass('err');
            }
        }

        var leftDays = (parent && parent.valid ? parent.span.getDayCount() - fields.map(function (period) {
            return (period.valid ? period.span.getDayCount() : 0);
        }).reduce(function (a, b) { return a + b; }, 0) : 1);

        let info = fields.map(function (period, index) {
            let $elem = $(period.elem);

            $elem.find('.period-outside-error').hide();
            $elem.find('.period-intersection-error').hide();
            $elem.find('.period-outside-intersection-error').hide();
            $elem.find('.period-equality-error').hide();

            let bullet = {
                elem: $(period.elem),
                period: period,
                index: index,
                active: false,
                intersects: false,
                outside: false,
                equality: false,
                showError: function (className) {
                    result.valid = this.period.valid = false;
                    toggleErrorHighlight(this.period, true);
                    this.elem.find(className).show();
                }
            };

            if (period.valid) {
                bullet.active = (options.sender === period.elemFrom[0] || options.sender === period.elemTo[0]);
                bullet.intersects = fields.some(function (p) {
                    return p.span !== undefined && period != p && period.span.intersects(p.span);
                });
                bullet.outside = parent && parent.valid && (period.dateFrom.goesBefore(parent.dateFrom) || parent.dateTo.goesBefore(period.dateTo));
                bullet.equality = parent && parent.valid && (period.dateFrom.isEqualTo(parent.dateFrom) && parent.dateTo.isEqualTo(period.dateTo));
            }

            return bullet;
        });

        let active = info.find(b => b.active);

        // Check on leftDays only if no intersections was found.
        if (info.every(b => !b.intersects && !b.outside) && !leftDays) {
            if (active !== undefined)
                active.equality = true;
            else
                info.find(b => { return b.period.valid && info.every(x => !x.period.valid || x.index <= b.index); }).outside = true;

            info.forEach(b => { b.period.valid = false; });
        }

        // Show intersection error on last if there is no active period
        if (info.some(b => b.intersects) && (active == undefined || !active.intersects)) {
            if (active !== undefined)
                active.active = false;
            info.find(b => b.intersects && info.every(x => !x.intersects || x.index <= b.index)).active = true;
        }


        info.forEach(function (bullet) {
            if (bullet.intersects) {
                bullet.period.valid = false;
                if (bullet.active && bullet.outside) {
                    bullet.showError('.period-outside-intersection-error');
                } else if (bullet.active) {
                    bullet.showError('.period-intersection-error');
                } else if (bullet.outside) {
                    bullet.showError('.period-outside-error');
                }
            } else if (bullet.equality) {
                bullet.showError('.period-equality-error');
            } else if (bullet.outside) {
                bullet.showError('.period-outside-error');
            }
        });
    }

    return result;
}




const fields = [DateField, DateIntervalField];

export { fields, DateIntervalField, DateField, baseDateIntervalCheck, DateIntervalIgnoreEmptyField };